import React from 'react'
import PropTypes from 'prop-types'

import './PricingColumnEntry.scss';

const PricingColumnEntry = (props) =>
    <li className="p-2">
        {props.name}
        {props.children}

        {
            props.new
            &&
            <sup className="new-feature"> New</sup>
        }
    </li>

PricingColumnEntry.displayName = 'PricingColumnEntry';
PricingColumnEntry.propTypes = {
    name: PropTypes.string,
    new: PropTypes.bool,
};

export default PricingColumnEntry;


// WEBPACK FOOTER //
// ./src/components/pricingcolumnentry/PricingColumnEntry.jsx